<!-- 患者詳細ポップアップ -->
<div class="popup-overlay" [class.show]="showPopup" (click)="onOverlayClick($event)">
  <div class="popup-content" (click)="$event.stopPropagation()">
    <div class="popup-header">
      <button class="popup-close-btn" (click)="closePopup()" style="margin: 15px 20px;">✕ 閉じる</button>
    </div>
    <div class="popup-body" *ngIf="patientDetail">
      <div class="popup-list-item patient-basic">
        <div class="popup-list-title">
          <span>{{ '患者' | hospLang }}ID</span>
        </div>
        <div class="popup-list-value">{{ patientDetail.patientId || '-' }}</div>
      </div>

      <div class="popup-list-item patient-basic">
        <div class="popup-list-title">
          <span>氏名</span>
        </div>
        <div class="popup-list-value">{{ patientDetail.patientName || '-' }}</div>
      </div>

      <div class="popup-list-item patient-basic">
        <div class="popup-list-title">
          <span>性別</span>
        </div>
        <div class="popup-list-value">{{ patientDetail.gender || '-' }}</div>
      </div>

      <div class="popup-list-item patient-basic">
        <div class="popup-list-title">
          <span>年齢</span>
        </div>
        <div class="popup-list-value">{{ getAgeText(patientDetail.age) }}</div>
      </div>

      <div class="popup-list-item patient-basic">
        <div class="popup-list-title">
          <span>部屋</span>
        </div>
        <div class="popup-list-value">{{ getRoomText(patientDetail.room) }}</div>
      </div>

      <div class="popup-list-item patient-basic" style="padding-bottom: 0.34375rem; border-bottom: none;">
        <div class="popup-list-title">
          <span>注意事項</span>
        </div>
        <div class="popup-list-value"></div>
      </div>
      <div class="popup-list-item patient-basic" style="padding-top: 0.34375rem; padding-bottom: 0.34375rem; border-bottom: none;">
        <div class="popup-list-title"></div>
        <div class="popup-list-value" style="display: flex; align-items: center;">
          <span style="font-size: 0.75rem; color: #333; margin-right: 0.5rem;">せん妄</span>
          <div style="flex: 1; font-size: 0.75rem;">{{ getDeliriumText(patientDetail.assessment?.delirium) }}</div>
        </div>
      </div>
      <div class="popup-list-item patient-basic" style="padding-top: 0.34375rem; padding-bottom: 0.34375rem;">
        <div class="popup-list-title"></div>
        <div class="popup-list-value" style="display: flex; align-items: center;">
          <span style="font-size: 0.75rem; color: #333; margin-right: 0.5rem;">転倒リスク</span>
          <div style="flex: 1; font-size: 0.75rem;">{{ patientDetail.assessment?.fallRisk || '-' }}</div>
        </div>
      </div>

      <div class="popup-list-item patient-basic" style="padding-bottom: 0.34375rem; border-bottom: none;">
        <div class="popup-list-title">
          <span>急変リスク</span>
        </div>
        <div class="popup-list-value"></div>
      </div>
      <div class="popup-list-item patient-basic" style="padding-top: 0.34375rem; padding-bottom: 0.34375rem; border-bottom: none;">
        <div class="popup-list-title"></div>
        <div class="popup-list-value" style="display: flex; align-items: center;">
          <img src="assets/images/icon/vital/HeartRate.svg" alt="心拍" style="width: 1.25rem; height: 1.25rem; margin-right: 0.5rem;">
          <span style="font-size: 0.75rem; color: #333; margin-right: 0.5rem;">心拍数</span>
          <div class="shape-indicator" [ngStyle]="getShapeStyle(patientDetail.vitalChangeRate?.heart)"></div>
        </div>
      </div>
      <div class="popup-list-item patient-basic" style="padding-top: 0.34375rem; padding-bottom: 0.34375rem; border-bottom: none;">
        <div class="popup-list-title"></div>
        <div class="popup-list-value" style="display: flex; align-items: center;">
          <img src="assets/images/icon/vital/Temperature.svg" alt="体温" style="width: 1.25rem; height: 1.25rem; margin-right: 0.5rem;">
          <span style="font-size: 0.75rem; color: #333; margin-right: 0.5rem;">体温</span>
          <div class="shape-indicator" [ngStyle]="getShapeStyle(patientDetail.vitalChangeRate?.temp)"></div>
        </div>
      </div>
      <div class="popup-list-item patient-basic" style="padding-top: 0.34375rem; padding-bottom: 0.34375rem;">
        <div class="popup-list-title"></div>
        <div class="popup-list-value" style="display: flex; align-items: center;">
          <img src="assets/images/icon/vital/SPO2.svg" alt="酸素" style="width: 1.25rem; height: 1.25rem; margin-right: 0.5rem;">
          <span style="font-size: 0.75rem; color: #333; margin-right: 0.5rem;">酸素飽和度</span>
          <div class="shape-indicator" [ngStyle]="getShapeStyle(patientDetail.vitalChangeRate?.oxygen)"></div>
        </div>
      </div>

      <div class="popup-list-item patient-basic">
        <div class="popup-list-title">
          <span>位置</span>
        </div>
        <div class="popup-list-value">{{ patientDetail.locationZone || patientDetail.movementStatus || '-' }}</div>
      </div>

      <div class="popup-list-item patient-basic">
        <div class="popup-list-title">
          <span>{{ '睡眠' | hospLang }}</span>
        </div>
        <div class="popup-list-value" style="display: flex; align-items: center;">
          <div class="shape-indicator" [ngStyle]="getSleepShapeStyle(patientDetail.sleepScore)"></div>
        </div>
      </div>

      <div class="popup-list-item patient-basic" style="flex-direction: column; align-items: flex-start;">
        <div class="popup-list-title" style="width: 100%; margin-bottom: 0.625rem;">
          <span>移動履歴（24時間以内）</span>
        </div>
        <div style="width: 100%;">
          <div *ngIf="patientDetail.movementHistory && patientDetail.movementHistory.length > 0">
            <div style="padding: 0.5rem 0; font-size: 0.875rem; border-bottom: 1px solid #f0f0f0;" *ngFor="let history of patientDetail.movementHistory">
              <span style="margin-right: 0.625rem;">{{ getTimeText(history) }}</span>
              <span>{{ getLocationText(history) }}</span>
            </div>
          </div>
          <div class="popup-no-data" *ngIf="!patientDetail.movementHistory || patientDetail.movementHistory.length === 0">
            24時間以内の移動履歴はありません
          </div>
        </div>
      </div>
    </div>
    
    <!-- ローディング表示 -->
    <div class="popup-loading" *ngIf="loadingDetail">
      <div>読み込み中...</div>
    </div>
  </div>
</div>
